import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import AdBanner from './AdBanner';
import './Footer.css';

/**
 * Application footer component
 * @param {Object} props - Component props
 * @param {boolean} props.showAds - Whether to display ads
 */
function Footer({ showAds }) {
  const currentYear = new Date().getFullYear();
  
  return (
    <footer className="app-footer">
      {showAds && <AdBanner position="footer" />}
      
      <div className="footer-content">
        <div className="footer-section">
          <div className="footer-logo">
            <span className="logo-icon">AI</span>
            <span className="logo-text">Code Implementer</span>
          </div>
          <p className="footer-description">
            An AI-assisted code implementation system that helps developers work efficiently 
            with AI coding assistants while keeping all project data private.
          </p>
        </div>
        
        <div className="footer-section">
          <h3 className="footer-heading">Navigation</h3>
          <ul className="footer-links">
            <li><Link to="/">Home</Link></li>
            <li><Link to="/projects">Projects</Link></li>
            <li><Link to="/about">About</Link></li>
            <li><Link to="/premium">Premium</Link></li>
          </ul>
        </div>
        
        <div className="footer-section">
          <h3 className="footer-heading">Resources</h3>
          <ul className="footer-links">
            <li><Link to="/docs">Documentation</Link></li>
            <li><Link to="/faq">FAQ</Link></li>
            <li><Link to="/tutorial">Tutorial</Link></li>
            <li><a href="https://github.com/example/ai-code-implementer" target="_blank" rel="noopener noreferrer">GitHub</a></li>
          </ul>
        </div>
        
        <div className="footer-section">
          <h3 className="footer-heading">Legal</h3>
          <ul className="footer-links">
            <li><Link to="/privacy">Privacy Policy</Link></li>
            <li><Link to="/terms">Terms of Service</Link></li>
            <li><Link to="/security">Security</Link></li>
            <li><Link to="/contact">Contact Us</Link></li>
          </ul>
        </div>
      </div>
      
      <div className="footer-bottom">
        <div className="footer-copyright">
          &copy; {currentYear} AI Code Implementer. All rights reserved.
        </div>
        
        <div className="footer-misc">
          <span>
            {showAds ? (
              <Link to="/premium" className="premium-link">Remove Ads with Premium</Link>
            ) : (
              <span className="premium-status">Premium User</span>
            )}
          </span>
        </div>
      </div>
    </footer>
  );
}

Footer.propTypes = {
  showAds: PropTypes.bool
};

Footer.defaultProps = {
  showAds: true
};

export default Footer;
